import * as Yup from 'yup'
import LookupType from './LookupType'

const InventoryRelocationOrderShipmentItem = Yup.object().shape({
    inventory_relocation_order_id: Yup.number().nullable(),
    product: LookupType,
    order_unit_type: LookupType,
    quantity_of_order_units: Yup.number().nullable(),
    items_per_order_unit: Yup.number().nullable(),
    quantity_of_single_units: Yup.number().nullable(),
    item_unit_type: LookupType,
    item_weight: Yup.number().nullable(),
})

export const InventoryRelocationOrderSchema = Yup.object().shape({
    id: Yup.number().nullable(),
    order_name: Yup.string().nullable(),
    order_number: Yup.string().nullable(),
    order_status: LookupType,
    
    from_inventory_location: LookupType,
    from_address_line_1: Yup.string().nullable(),
    from_city: Yup.string().nullable(),
    from_state: Yup.string().nullable(),
    from_zip_code: Yup.string().nullable(),
    
    to_inventory_location: LookupType,
    to_address_line_1: Yup.string().nullable(),
    to_city: Yup.string().nullable(),
    to_state: Yup.string().nullable(),
    to_zip_code: Yup.string().nullable(),
    
    remarks: Yup.string().nullable(),

    shipment_items: Yup.array(InventoryRelocationOrderShipmentItem).nullable()
})
